import { RootReducerState } from '../index';
import { INITIAL_LOADING } from '../slices/app-state/app-state.consts';

export const selectIsRudderstackLoadingCompleted = (state: RootReducerState): boolean =>  !state.appReducer.initialLoadings.includes(INITIAL_LOADING.LOAD_RUDDERSTACK);
